
export default {
  name: 'Footer',
  props: [],
  methods: {

  }
}
